import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <p>Explore our collection of fine teas and ceramics!</p>
          <Link to="/shop" onClick={toTop} className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-container container">
        <h1 className="cart-title">Your cart</h1>

        <div className="free-shipping-bar">
          <p>Spend <strong>${Math.max(0, (200 - subtotal)).toFixed(2)}</strong> more to reach free shipping!</p>
          <div className="progress">
            <div className="progress-inner" style={{ width: `${Math.min(100, (subtotal / 200) * 100)}%` }} />
          </div>
        </div>

        <table className="cart-table" role="table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map((item, idx) => {
              const product = getProductById(item.id);
              const price = product ? parseFloat(String(product.price).replace(/,/g, "")) : 0;
              return (
                <tr key={idx} className="cart-row">
                  <td className="product-col">
                    <div className="product-item">
                      <img src={product?.image} alt={product?.name} />
                      <div className="product-info">
                        <div className="product-name">{product?.name}</div>
                        <div className="product-attrs">
                          <div>Color: <strong>{item.color || "-"}</strong></div>
                          <div>Size: <strong>{item.size || "-"}</strong></div>
                        </div>
                        <button className="remove-link" onClick={() => removeFromCart(item.id, item.size, item.color)}>Remove</button>
                      </div>
                    </div>
                  </td>

                  <td className="price-col">${price.toFixed(2)}</td>

                  <td className="qty-col">
                    <div className="qty-control">
                      <button onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}>−</button>
                      <input type="text" readOnly value={item.quantity} />
                      <button onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}>+</button>
                    </div>
                  </td>

                  <td className="total-col">${(price * item.quantity).toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="cart-footer">
          <div className="cart-left" />
          <aside className="cart-summary">
            <div className="summary-box">
              <h3>Estimated total</h3>
              <div className="summary-amount">${subtotal.toFixed(2)} USD</div>
              <p className="summary-note">Taxes and <Link to="/shipping">Shipping</Link> calculated at checkout</p>
              <button className="checkout-btn" onClick={handleCheckout}>Check Out</button>
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
